// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:inline-block}:host(:not([width])){display:block}.placeholder{position:relative;border-radius:var(--uap-border-radius);background:var(--uap-color-placeholder-gray);color:rgba(0,0,0,0);animation:shimmer 1s steps(10) 1s infinite alternate;width:100%;height:.6666666667em}@keyframes shimmer{0%{opacity:1}100%{opacity:.25}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
